module.exports = __webpack_public_path__ + "img/why-m.a14d1955.jpg";